<div class="pip-controls">
  <button class="btn btn-light btn-round mr-2" (click)="toggleSize()">
    <fa-icon
      [icon]="['fas', 'up-right-and-down-left-from-center']"
      [rotate]="270"
    ></fa-icon>
  </button>
  <button class="btn btn-light btn-round" (click)="close()">
    <fa-icon [icon]="['fas', 'xmark']"></fa-icon>
  </button>
</div>
<ng-content></ng-content>
